const menu = [
    {name: 'dashboard', title: 'dashboard', icon: 'fe-airplay mdi-24px', new: false},
    {
        title: 'administracija', icon: 'fe-book-open mdi-24px', new: false, children: [
            {name: 'pregledZaposlenih', title: 'zaposleni', new: false},
            {name: 'podaciFirme', title: 'podaciFirme', new: false},
            {name: 'organizacionaStruktura', title: 'organizacionaStruktura', new: false},
            {name: 'tipoviVozila', title: 'tipoviVozila', new: false},
            {name: 'grupeVozila', title: 'grupeVozila', new: false},
            {name: 'statusiVozila', title: 'statusiVozila', new: false},
            {name: 'markeVozila', title: 'markeVozila', new: false},
            {name: 'opremaVozila', title: 'opremaVozila', new: false},
            {name: 'poslovniPartneri', title: 'poslovniPartneri', new: false},
            {name: 'podesavanjeSistema', title: 'podesavanjeSistema', new: false},
            {name: 'korisnickeTransakcije', title: 'korisnickeTransakcije', new: false},
        ]
    },
    {
        title: 'flota', icon: 'mdi mdi-train-car mdi-24px', new: false, children: [
            {name: 'vozila', title: 'vozniPark', new: false},
            {name: 'gps', title: 'GPS', new: false},
        ]
    },
    {
        title: 'podsetnici', new: false, icon: 'mdi mdi-email mdi-24px', children: [
            {name: 'pregledPodsetnikaVozila', title: 'podsetniciVozila', new: false},
            {name: 'pregledPodsetnikaOsoba', title: 'podsetniciOsoba', new: false},
            {name: 'pregledPodsetnikaPoPrimaocima', title: 'pregledPodsetnikaPoPrimaocima', new: false}
        ]
    },
    {
        title: 'odrzavanje', icon: 'fas fa-wrench mdi-24px', new: false, children: [
            {
                title: 'administracija', children: [
                    {name: 'vrsteOdrzavanja', title: 'vrsteOdrzavanja', new: false},
                    {name: 'grupeDelova', title: 'grupeDelova', new: false},
                    {name: 'servisneOperacije', title: 'servisneOperacije', new: false},
                    {name: 'vrsteTroskovaVozila', title: 'vrsteTroskovaVozila', new: false},
                    {name: 'rezervniDelovi', title: 'rezervniDelovi', new: false},
                ]
            },
            {
                title: 'prijavaKvara', children: [{name: 'prijavaKvara', title: 'prijavaKvara', new: false},
                    {name: 'odobravanjePrijaveKvara', title: 'odobravanjePrijaveKvara', new: false},],
            },
            {
                title: 'radniNalozi', children: [
                    {name: 'radniNalog', title: 'radniNalog', new: false},
                    {name: 'potvrdaRadnihNaloga', title: 'potvrdaRadnihNaloga', new: false}
                ]
            },
            {
                title: 'fakture', children: [
                    {name: 'servisnaFaktura', title: 'servisnaFaktura', new: false},
                    {name: 'fakturaTroskovaVoznogParka', title: 'fakturaTroskovaVoznogParka', new: false},
                ]
            },
            {
                title: 'stete', new: true, icon: 'mdi mdi-airbag mdi-24px', children: [
                    {name: 'unosStete', title: 'unosStetnogDogadjaja', new: false},
                    {name: 'pregledSteta', title: 'pregledSteta', new: false},
                ]
            },
            {
                title: 'skladisteDelova', children: [
                    {name: 'izdatnica', title: 'izdatnica', new: false},
                    {name: 'potvrdaPovratnice', title: 'potvrdaPovratnice', new: false},
                ]
            },
            {
                title: 'zalihe', children: [
                    {name: 'prijemnica', title: 'prijemnica', new: false},
                    {name: 'pregledZaliha', title: 'pregledZaliha', new: false},
                ]
            },
            {
                title: 'izvestaji', children: [
                    {title: 'pretragaDokumenata', name: 'pretragaDokumenata'},
                    {name: 'izvestajiTroskoviVozila', title: 'izvestajiTroskoviVozila', new: false},
                    {name: 'analitikaTroskovaVozila', title: 'analitikaTroskovaVozila', new: true},
                ]
            }
        ]
    },
    {
        title: 'evidencijaRV', new: false, icon: 'fas fa-user-clock', children: [
            {name: 'uvozTahografa', title: 'uvozTahografa', new: false},
            {name: 'unosOdsustva', title: 'unosOdsustva', new: false},
            {name: 'unosAktivnostiIObradaGpsPodataka', title: 'unosAktivnostiIObradaGpsPodataka', new: false},
            {
                title: 'izvestaji', children: [
                    {name: 'evidencijaRadnogVremena', title: 'evidencijaRadnogVremena', new: false},
                    {name: 'pregledReferentnihPerioda', title: 'pregledReferentnihPerioda', new: false},
                    {name: 'izvestajPreostalogRadnogVremena', title: 'izvestajPreostalogRadnogVremena', new: false},
                    {name: 'naloziZaSluzbenaPutovanja2', title: 'naloziZaSluzbenoPutovanje', new: false},
                ]
            },
        ]
    },
    {
        title: 'putniNalozi', new: false, icon: 'mdi mdi-file-document-edit-outline mdi-24px', children: [
            {name: 'unosPutnogNaloga', title: 'unosPutnogNaloga', new: false},
            {name: 'pregledPutnihNaloga', title: 'pregledPutnihNaloga', new: false},
            {name: 'naloziZaSluzbenoPutovanje', title: 'naloziZaSluzbenoPutovanje', new: false},
        ]
    },
    {
        title: 'uvozPodataka', new: false, icon: 'mdi mdi-cloud-upload mdi-24px', children: [
            {name: 'uvozTahografa', title: 'uvozTahografa', new: false},
            {name: 'uvozSipanjaGoriva', title: 'uvozSipanjaGoriva', new: false},
            {name: 'uvozKretanjaVozila', title: 'uvozKretanjaVozila', new: false},
        ]
    },
    {
        title: 'izvestaji', new: true, icon: 'mdi mdi-chart-bar mdi-24px', children: [
            {
                title: 'troskovi', children: [

                    {name: 'izvestajiTroskoviVozila', title: 'izvestajiTroskoviVozila', new: false},
                    {name: 'troskoviPoVozilima', title: 'troskoviPoVozilima', new: false},
                    {name: 'analitikaTroskovaVozila', title: 'analitikaTroskovaVozila', new: true},
                ]
            },
            {
                title: 'gorivo', children: [
                    {name: 'evidencijaSipanjaGoriva', title: 'evidencijaSipanjaGoriva', new: false},
                ]
            },
            {
                title: 'kretanje', children: [
                    {name: 'predjeniKilometriIPotrosnjaGoriva', title: 'predjeniKilometriIPotrosnjaGoriva', new: false},
                    {name: 'predjeniKilometri', title: 'izvestajPredjeniKilometri', new: false},
                    {name: 'pregledKretanjaVozila', title: 'pregledKretanjaVozila', new: false},
                    {name: 'pregledKretanjaVozaca', title: 'pregledKretanjaVozaca', new: false},
                ]
            },
            {
                title: 'radnoVreme', children: [
                    {name: 'evidencijaRadnogVremena', title: 'evidencijaRadnogVremena', new: false},
                    {name: 'pregledReferentnihPerioda', title: 'pregledReferentnihPerioda', new: false},
                    {name: 'izvestajPreostalogRadnogVremena', title: 'izvestajPreostalogRadnogVremena', new: false},
                ]
            },
        ]
    }
];

export default menu;
